/**
 * @generated SignedSource<<a43ab48b7939840ac0d94842935d57f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type integrations_Settings_Fragment$data = {
  readonly leadfeederTracker: string | null | undefined;
  readonly salesforceMid: string | null | undefined;
  readonly zoomInfoTracker: string | null | undefined;
  readonly " $fragmentType": "integrations_Settings_Fragment";
};
export type integrations_Settings_Fragment$key = {
  readonly " $data"?: integrations_Settings_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"integrations_Settings_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "integrations_Settings_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salesforceMid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leadfeederTracker",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zoomInfoTracker",
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo_Znglyinfo",
  "abstractKey": null
};

(node as any).hash = "6f373e9107f7b2be8db8c0f9427b77cc";

export default node;
